<template>
  <div>
    <div class="banner"></div>
    <div class="mculture">
      <van-tabs :ellipsis="false" v-model="activeName" @change="tabchange">
        <van-tab title="文化理念" name="文化理念">
          <div
            v-if="activeName == '文化理念'"
            style="background: rgba(244, 246, 249, 0.5); padding: 4vw"
          >
            <div
              style="
                width: 100%;
                background: #fff;
                position: relative;
                padding: 9.07vw 3.2vw 0.27vw 3.2vw;
              "
            >
              <img
                src="../../assets/image/surveyintro.png"
                alt=""
                style="
                  width: 6.93vw;
                  height: 5.87vw;
                  position: absolute;
                  top: 0;
                  left: 3.2vw;
                "
              />
              <div class="dl">
                <span class="blue">中铁建工一公司</span>
                1953年建处，历经70年风雨考验，传承“永远的开路先锋”精神，磨砺了“召之即来、来之能战、战之必胜”的坚毅品格，深刻体会到“市场如战场”“现场如战场”。为了更好地传承发扬优良传统、在新时代建新功，2020年一公司总结提炼了“既讲竞争又讲关怀、既讲拼搏又讲团结”的“战场文化”，并以其为核心，
                <span class="blues">
                  打造了“改革文化、执行文化、竞争文化、用才文化、团结文化、现场文化、铁军文化”七种文化的支撑体系
                </span>
                。
              </div>
              <div class="dl">
                <span class="blue"
                  >一是坚持锐意进取、守正创新，打造与时俱进、勇于开拓的改革文化。</span
                >“惟改革者进，惟创新者强，惟改革创新者胜”，在商业竞争的战场上，只有不断改革创新，才能适者生存。公司以进取精神打破固有经营格局，走出“革命老区”，稳住战略主阵地的同时，奋力开拓新区域市场、新专业领域，形成了“1+6”区域市场、“区域经营+专业经营+大客户经营”的新格局。立足管理实际，强化后台管控，守正管理基础；增加经营性事业部和专业管理部门，创新管理模式，提高管理效率。公司上下形成不断对标先进、不断总结提升的改革共识，通过改革赋能，公司生产经营战果不断取得新突破、冲向新高地。
              </div>
              <div class="dl">
                <span class="blue"
                  >二是坚持整章建制、强化监督，打造军令如山、令行禁止的执行文化。</span
                >在战场上，强大的执行力是获得胜利的根本保证，为打造强有力的执行力文化，公司全面加快制度建设步伐，近年来梳理调整制度208项，全面提升管理规范化、标准化水平。与此同时，创新监督模式，融合政治监督与专项监督，成立大监督检查组，严格监督制度执行和部门履职情况，对制度执行不力、履职不力加大处罚整改力度。大监督工作开展以来，累计发现问题千余条，均依纪按律限期整改，全员纪律意识、规矩意识大幅提升，以铁的纪律、铁的作风、铁的执行打造钢铁队伍成为广泛的思想共识。
              </div>
              <div class="dl">
                <span class="blue">
                  三是坚持奖优罚劣、比学帮超，打造绩效为先、协同共进的竞争文化。</span
                >发扬“勇当先锋做表率、奋勇争先竞一流”的竞争精神，打造新时代“先锋战队”。不断完善岗位分级评价标准，推进两级绩效考核体系建设，首次实现考核全级、全员覆盖。强化考核结果刚性兑现，加大薪酬、奖金差异化、精准化分配力度，打破“高水平大锅饭”，倒逼全员能力素质提升。把公司做为大型“练兵场”，通过述职点评、定期亮晒、重点帮扶、专项培训，既鼓励先进又拉动后进；以“老带新”“传帮带”，实战练兵促进新人成长，形成了“打仗亲兄弟、上阵父子兵”携手共进的良好氛围。
              </div>
              <div class="dl">
                <span class="blue"
                  >四是坚持揭榜挂帅、末位淘汰，打造公开透明、能上能下的用才文化。</span
                >“千军易得，一将难求”，将帅是决定战争能否取胜的关键。为了更好的选拔人才，公司升级“公开选、择优定、动态管、滚动变”的人才公开选拔机制，常态化组织“点将”竞聘，以揭榜挂帅方式，累计公开选拔并任用干部143人;重点关注关键岗位人才培养，连续四年开展储备人才公开竞聘，100余人选为后备干部。建立全员轮岗制度，实行动态考评和末位淘汰,强化考核应用，流程公开透明，真正做到“能者上、平者让、庸者下”。良好的用才文化成为公司培育将帅之才的优渥土壤。
              </div>
              <div class="dl">
                <span class="blue"
                  >五是坚持服务基层、关注长远，打造兴企为民、共同发展的团结文化。</span
                >“团结就是力量，团结才能胜利”。公司扎实构建“大关爱”体系，持续加大慰问频次、力度，年均开展各类关心关爱活动近百次，发放各类慰问金五百余万元，让广大职工群众共享企业发展成果；关注工友职业发展和切身利益，创建以“富心、富能、富裕”为核心的“京彩工匠”融媒体平台，为工友打造专属的安全教育和技能提升阵地，连续四年开展“京彩工匠”品牌活动，构建工友与企业的“命运共同体”，与此同时，作为中铁首个农民工专属教育平台，相关经验总结得到国资委的高度认可，并在《国资交流》刊发。公司上下形成同心共圆的强大合力。
              </div>
              <div class="dl">
                <span class="blue"
                  >六是坚持谋定后动、过程卡控，打造严慎细实、极致履约的现场文化。</span
                >秉持“工地就是阵地、现场就是战场”的理念，不打无准备之仗，组建专业部门负责工程策划，制定施工“作战图”，一项一策，无策划不施工，为各项目顺利推进、严慎细实地实现五大管理目标夯实作战基础。秉持“战场形势瞬息万变必须顺势而动”的理念，大力推进全要素、全模块的标准化建设，通过加强前后台联动，落实样板引路、进度预警、红线管控、效益比拼等全方位、全过程管控手段，为实现极致履约提供坚强保障。良好的现场文化为公司实现“以现场保市场”、不断巩固扩大市场阵地创造了有利条件。
              </div>
              <div class="dl">
                <span class="blue">
                  七是坚持勇担责任、奋勇拼搏，打造上下一心、敢打必胜的铁军文化。</span
                >从1959年仅用7个月零20天建成了永载共和国史册的北京站开始，“挂图作战、期到必成”的铁军精神就被作为我们优秀的企业文化基因传承至今。2020年雄安站创造“雄安速度”“雄安质量”，被习总书记誉为“千年大计的开路先锋”，公司站在了新时代的潮头上勇毅前行。铁军精神是深深印刻在公司每名干部职工心中的文化烙印，在新时代我们将继续传承这一伟大精神，秉承新发展理念，弘扬“战场文化”，锻造一支敢啃硬骨头、敢打主动仗的精兵劲旅，在急难险重任务面前勇于担当，在复杂多变问题面前迎难而上，在高严要求中强化战斗本领，在担当尽责中践行初心使命。
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="文化活动" name="文化活动">
          <div
            v-if="activeName == '文化活动'"
            style="background: rgba(244, 246, 249, 0.5); padding: 3.2vw 4vw"
          >
            <div
              class="culturelist"
              v-for="(i, j) in newslist"
              :key="j"
              @click="checkinfo(i, j)"
              @touchstart="changecolor(j)"
              @touchend="colorstyle = -1"
            >
              <div class="listicon">
                <img :src="i.firstUrl" alt="" class="listimg" />
                <div class="listtime" style="display: flex">
                  {{ i.createTime }}
                </div>
              </div>
              <div class="listcontent">
                <h1
                  class="listtitle"
                  :style="{
                    color: colorstyle == j ? 'rgba(25, 97, 172, 1)' : '#06192D',
                  }"
                >
                  {{ i.title }}
                </h1>
                <p class="listcon">{{ i.summary }}</p>
              </div>
            </div>
            <div class="pagination">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="pagesize.total"
                :page-size="pagesize.size"
                @current-change="getlist"
                :current-page.sync="pagesize.page"
              >
              </el-pagination>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      activeName: "文化理念",
      colorstyle: -1,
      newslist: [],
      hoverindex: -1,
      sendnews: {},
      pagesize: { page: 1, size: 10, total: 0 },
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    checkinfo(e) {
      let data = {
        category: "品牌文化/文化活动",
        id: e.id,
        current: 1,
        size: 999,
      };
      this.$router.push({
        path: "/mnewsinfo",
        query: data,
      });
    },
    async getlist() {
      try {
        let data = {
          category: "品牌文化/文化活动",
          current: this.pagesize.page,
          size: this.pagesize.size,
        };
        const res = await this.$http.newslist(data);
        if (res.code == 200) {
          this.newslist = res.data;
        } else {
          // 处理错误情况
          console.log("Error fetching build list:", res.message);
        }
      } catch (error) {
        console.error("An error occurred while fetching the list:", error);
      }
    },
    changecolor(e) {
      this.colorstyle = e;
    },
    gotonewinfo() {
      this.$router.push({
        path: "/mnewsinfo",
      });
    },
    tabchange(e) {
      this.activeName = e;
      console.log(e);
    },
    scrolls(e) {
      // console.log(e.target.scrollLeft);
    },

    turnto(e) {
      window.open(e);
    },
    handleClick(f) {
      this.fathernum = f.index;
      this.activechild = 0;
      for (let i in this.tabslist) {
        if (i == f.index) {
          if (this.tabslist[i].children.length > 0) {
            for (let j in this.tabslist[i].children) {
              if (j == 0) {
                this.senddata = this.tabslist[i].children[j].content;
              }
            }
          } else {
            this.senddata = this.tabslist[i].content;
          }
        }
      }
    },
    cultureclik(e) {
      this.cultureclicks = e;
    },
  },
};
</script>

<style scoped lang="less">
.blues {
  color: rgba(25, 97, 172, 1);
}
.blue {
  color: rgba(25, 97, 172, 1);
  font-weight: 600;
}
.dl {
  font-size: 3.73vw;
  line-height: 5.87vw;
  color: rgba(18, 20, 58, 0.8);
  margin-bottom: 3.2vw;
}
.banner {
  width: 100%;
  height: 42.67vw;
  background: url("https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/mculturetop.png")
    no-repeat;
  /* background-position: 0 0; */
  background-size: 100%;
}

.mculture {
  .culturelist {
    .listcontent {
      .listcon {
        font-size: 12px;
        height: 50px;
        pointer-events: none;
        color: rgba(6, 25, 45, 0.68);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }

      .listtitle {
        font-size: 15px;
        color: #000;
        margin-bottom: 0.83vw;
        pointer-events: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 20px;
      }

      flex: 1;
      display: flex;
      flex-direction: column;
      pointer-events: none;
      width: 211px;
    }

    .listicon {
      .listtime {
        position: absolute;
        bottom: 0;
        left: 0;
        pointer-events: none;
        width: 100%;
        height: 28px;
        background: rgba(3, 109, 220, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 14px;
      }

      .listimg {
        width: 100%;
        height: 100%;
        pointer-events: none;
      }

      width: 100px;
      height: 80px;
      position: relative;
      margin-right: 10px;
      pointer-events: none;
    }

    width: 100%;
    height: 104px;
    background: #fff;
    padding: 12px;
    display: flex;
    margin-bottom: 2.67vw;
  }

  width: 100%;
  background-size: 100% 100%;
  background-position: 0 0;
  background: rgba(244, 246, 249, 0.5);
}

#tab-culturelist {
  left: 15px;
  top: 7px;
  width: 60px;
  height: 21px;
  opacity: 1;

  font-family: Alibaba PuHuiTi 2;
  font-size: 55px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0em;

  font-feature-settings: "kern" on;
  color: #1961ac;
}

::v-deep .van-tabs__item {
  padding: 0 7px;
  margin-left: 15px;
}

::v-deep .van-tab__pane {
  display: flex !important;
  flex-direction: column;
  gap: 10px;
}
::v-deep .van-tabs__line {
  width: 60px;
  height: 2px;
  border-radius: 4px 4px 0 0;
  background: #1668bc;
  opacity: 1;
  color: #1668bc;
}
.pagination {
  height: unset;
}
::v-deep .el-pagination {
  margin-bottom: 1.33vw;
}
::v-deep .btn-next {
  border: unset;
  width: 6.4vw;
  height: 6.4vw;
}
::v-deep .btn-prev {
  border: unset;
  width: 6.4vw;
  height: 6.4vw;
}
::v-deep .number {
  width: 6.4vw;
  height: 6.4vw;
  min-width: unset !important;
  line-height: 6.4vw;
  border: 1px solid rgba(215, 216, 217, 1);
  border-radius: 4px !important;
  font-size: 3.2vw !important;
  text-align: center;
  color: rgba(6, 25, 45, 0.68) !important;
  font-weight: normal !important;
}
::v-deep .el-pager li.active {
  color: #fff !important;
}
::v-deep .van-tab--active {
  color: #1961ac !important;
  font-size: 4vw;
  // font-size: 4vw;
}
</style>
